<template>
  <svg
    width="64"
    height="64"
    viewBox="0 0 96 96"
    fill="#1A1A1A"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Double arrow" clip-path="url(#clip0_1_581)" opacity="0.6">
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M56 16H38L58 48L38 80H56L76 48L56 16Z"
            fill="#2F2F2F" />
          <path
            id="Vector_2"
            d="M28 16H10L30 48L10 80H28L48 48L28 16Z"
            fill="#2F2F2F" />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_581">
        <rect width="96" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
